import React from "react";
import "./Footer.css"; // Assuming you have a separate CSS file
import Nifty10Logo from "../../assets/Nifty10-logo-white.png";
import PlayStore from "../../assets/GetItOnGooglePlay_Badge.png";
import AppStore from "../../assets/GetItOnApp_Store_Badge.svg"
import Juspay from "../../assets/juspay.svg";
// import Razorpay from "../../assets/razorpay.svg";
import Facbook from "../../assets/facebook-logo.png";
import Instagram from "../../assets/instagram-logo.png";
import Twitter from "../../assets/x-logo.png";
import Youtube from "../../assets/youtube-logo.png";
import Telegram from "../../assets/telegram-logo.png";
import Whatsapp from "../../assets/whatsapp-logo.png";
import Linkedin from "../../assets/linkedin.png";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const mobileHideRoutes = ['/about-us', '/terms-conditions', '/refund-policy','/points-system','/privacy-policy','/play-guide','/help-desk'];
  const hideLinksMobile = mobileHideRoutes.includes(location.pathname);
  const hideAddressOnRoutes = ['/', '/home']; // Add more if needed
const hideAddress = hideAddressOnRoutes.includes(location.pathname);

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-logo">
          <h2>
            <img
              className="footer-logo-img"
              src={Nifty10Logo} 
              alt="Nifty10 Logo"
            />
            <span className="highlight">Nifty</span>10
          </h2>
          <div className={`store-buttons ${hideLinksMobile ? 'hide-links-mobile' : ''}`}>
          <a href="https://play.google.com/store/apps/details?id=com.finpages.nifty" target="_blank" rel="noopener noreferrer"><img src={PlayStore} alt="Play Store" className="play-store-icon"/></a>
            <a href="https://apps.apple.com/in/app/nifty10/id6748718480" target="_blank" rel="noopener noreferrer"><img src={AppStore} alt="App Store" className="app-store-icon"/></a>
          </div>
        </div>
        
          <div className={`footer-links ${hideLinksMobile ? 'hide-links-mobile' : ''}`}>
  <div className="footer-heading">
    <h4>Quick links</h4>
  </div>
  <div>
    <ul>
      <li><a href="/winners">Nifty 10 Winners</a></li>
      <li><a href="/disclaimer">Disclaimer</a></li>
      {/* <li><a href="/refund-policy">Refund Policy</a></li> */}
      <li><a href="/privacy-policy">Privacy Policy</a></li>
      <li><a href="/terms-conditions">Terms & Conditions</a></li>
      <li><a href="/legal-opinion-skilled-game">Legal Opinion</a></li>
    </ul>
  </div>
  <div>
    <ul>
      <li><a href="/about-us">About Us</a></li>
      <li><a href="/help-desk">Helpdesk</a></li>
      <li><a href="/contact-us">Contact Us</a></li>
      {/* <li><a href="/product-pricing">Product Pricing</a></li> */}
      <li><a href="/points-system">Points System</a></li>
      <li><a href="/play-guide">How to play</a></li>
    </ul>
  </div>
</div>


          <div className="footer-info">
            {/* <h4>Payment partners</h4> */}
            {/* <div className="payment-partners">
              <img src={Juspay} alt="Juspay" />
              <img src="https://airpay.ae/resources/images/airpay-text.png" alt="Razorpay" />
            </div> */}
            <div className={` ${hideLinksMobile ? 'hide-links-mobile' : ''}`}>
            <h4 className="footer-icons">Connect with us</h4>
            <div className="social-icons">
              <a href="https://www.linkedin.com/company/finpagestech" target="_blank"><img src={Linkedin} alt="Linkedin" /></a>
              <a href="https://www.instagram.com/nifty10game?igsh=MXd1bmphYnMzdThiMw==" target="_blank"><img src={Instagram} alt="Instagram" /></a>
              <a href="https://x.com/Nifty10Game" target="_blank"><img src={Twitter} alt="X" /></a>
              <a href="https://youtube.com/@nifty10game?si=kb7Aeyt7fixJx97E" target="_blank"><img src={Youtube} alt="YouTube" /></a>
              <a href="https://wa.me/+919490841941" target="_blank"><img src={Whatsapp} alt="Whatsapp" /></a>
              <a href="https://t.me/+919490841941" target="_blank"><img src={Telegram} alt="Telegram" /></a>
            </div></div>
          </div>
{!hideAddress && (
  <div className="footer-address">
    <p><strong className="privacy-sub-list-item">Corporate Office :</strong> #709, Gowra Fountain Head, HUDA Techno Enclave, Mindspace Rd, HITEC City, Hyderabad, Telangana 500081</p>
    <p><strong className="privacy-sub-list-item">Registered Office :</strong> 8-3-231/A/278 & 279, Flat No. 404, Sri Krishna Nagar, Yousufguda, Khairatabad, Hyderabad – 500045, Telangana</p>
  </div>
)}

        </div>

        <div className="footer-bottom">



  {/* <p className="disclaimer">
    This game involves an element of financial risk and may be addictive. Please play responsibly at your own risk. The game is applicable for people above 18 only.
  </p> */}
  <p className="copyright">
    &copy; {new Date().getFullYear()} Nifty10. All rights reserved.
  </p>
</div>



    </footer>
  );
};

export default Footer;
